<template>
  <Navigation>
    <GoogleTranslatorButton />
    <transition name="slide-x-transition" mode="out-in">
      <router-view />
    </transition>
  </Navigation>
</template>

<script>
import { mapState } from "vuex";
import Navigation from "@/components/Navigation";
import GoogleTranslatorButton from "@/components/GoogleTranslatorButton";

export default {
  name: "App",
  components: {
    Navigation,
    GoogleTranslatorButton,
  },
  computed: {
    ...mapState(["user"]),
  },
  created() {
    if (this.user) {
      this.$store.dispatch("getUserInfo");
      setTimeout(() => {
        this.$store.dispatch("updateMe");
      }, 500);
    }
  },
};
</script>

<style>
.v-content__wrap {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue